//我的教室-教师接口 Api
import request from "@/config/_request";
import qs from "qs";

// 获取教室首页数据
export function getTchIndexInfo() {
  return request({
    url: "/api/tch/get/indexinfo",
    method: "get"
  });
}

// 获取班级管理页面数据
export function getTchClasslist(params) {
  return request({
    url: "/api/tch/class/get/classlist",
    params,
    method: "get"
  });
}


// 获取班级对应的教学计划
//入参
//class_id 班级id 必填 
//page_no 页码 
//page_size 每页大小
export function getTchTeachingPlan(params) {
  return request({
    url: "/api/tch/get/teaching/plan/list",
    params,
    method: "get"
  });
}

//教师查询讲次对应的学生课堂作品和课后作业完成情况
export function tchGetStuTchPlanListByTchId(params) {
  return request({
    url: "/api/tch/get/stu/tch/plan/list/by/tch/id",
    params,
    method: "get"
  });
}

//作品打分接口
export function tchSaveTchWorkScore(params) {
  return request({
    url: "/api/tch/save/tch/work/score",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得老师课表
export function tchGetTchTimetable(params) {
  return request({
    url: "/api/tch/get/tch/timetable",
    params,
    method: "get"
  });
}

//作业点评接口
export function tchGetTchStuTchWorkList(params) {
  return request({
    url: "/api/tch/get/tch/stu/tch/work/list",
    params,
    method: "get"
  });
}

//获得学生自由创作作品
export function tchGetTchStuWorkList(params) {
  return request({
    url: "/api/tch/get/tch/stu/work/list",
    params,
    method: "get"
  });
}

//获得老师具有的科目权限
export function tchGetTchSubjectAuth(params) {
  return request({
    url: "/api/tch/get/tch/subject/auth",
    params,
    method: "get"
  });
}

//获得老师课程体系接口
export function tchGetTchCurriculum(params) {
  return request({
    url: "/api/tch/get/tch/curriculum",
    params,
    method: "get"
  });
}

//老师删除学员作品
export function tchDeleteTchWork(params) {
  return request({
    url: "/api/tch/delete/tch/work",
    data: qs.stringify(params),
    method: "post",
  });
}
//添加或更新套餐
export function tchWorkSelfRemarkCreateOrUpdate(params) {
  return request({
    url: "/api/tchWorkSelfRemark/createOrUpdate",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得教师评语列表
export function tchWorkSelfRemarkGet(params) {
  return request({
    url: "/api/tchWorkSelfRemark/get",
    params,
    method: "get"
  });
}
//删除教师评语
export function tchWorkSelfRemarkDelete(params) {
  return request({
    url: "/api/tchWorkSelfRemark/delete",
    data: qs.stringify(params),
    method: "post",
  });
}

//同步模板页面获得教学计划列表
export function getTchPlanListForAddTmp(params) {
  return request({
    url: "/api/getTchPlanListForAddTmp",
    params,
    method: "get"
  });
}

//批量更新教学计划模板
export function bulkUpdateTchPlanTemplate(params) {
  return request({
    url: "/api/bulkUpdateTchPlanTemplate",
    data: qs.stringify(params),
    method: "post",
  });
}

//批量重置教学计划模板
export function bulkResetTchPlanTemplate(params) {
  return request({
    url: "/api/bulkResetTchPlanTemplate",
    data: qs.stringify(params),
    method: "post",
  });
}

//选择可以恢复的作品列表，老师作品及学员作品
export function getWorkListForCopyToStuTchPlan(params) {
  return request({
    url: "/api/getWorkListForCopyToStuTchPlan",
    params,
    method: "get"
  });
}

//将模板作品赋值给学生教学计划
export function tmpWorkCopyToStuTchPlan(params) {
  return request({
    url: "/api/tmpWorkCopyToStuTchPlan",
    data: qs.stringify(params),
    method: "post",
  });
}